function closePopup() {
  const now = new Date();
  localStorage.setItem('popup_dismissed_at', now.getTime());
}

if (!localStorage.getItem('popup_session_start')) {
    localStorage.setItem('popup_session_start', Date.now());
}  

function shouldShowPopup() {
  const lastDismissed = localStorage.getItem('popup_dismissed_at');
  const lastShown = localStorage.getItem('popup_last_shown');
  const now = new Date().getTime();

  const dismissedRecently = lastDismissed && (now - parseInt(lastDismissed)) < 3 * 60 * 60 * 1000; // 3h
  const alreadyShownToday = lastShown && new Date(parseInt(lastShown)).toDateString() === new Date().toDateString();

console.log(dismissedRecently, alreadyShownToday)

  return !dismissedRecently && !alreadyShownToday
}


function showPopup() {
    window._klOnsite = window._klOnsite || [];
    if(Shopify.locale == 'de') {
        window._klOnsite.push(['openForm', 'SRLvgt']);
    } else {
        window._klOnsite.push(['openForm', 'UnaakV']);
    }
    localStorage.setItem('popup_last_shown', new Date().getTime()); 
    localStorage.removeItem('popup_session_start');
}

document.addEventListener("DOMContentLoaded", function () {
  if (shouldShowPopup()) {
    setTimeout(() => {
            // Exit intent on desktop
    document.addEventListener('mouseleave', function (e) {
        if(shouldShowPopup()) {
          showPopup();
          }
      });
  
      // Exit intent on mobile: detect fast upward scroll
  
      let lastScrollTop = window.scrollY;
      let lastTime = Date.now();
     
  
      window.addEventListener('scroll', function() {
      //   console.log(window.scrollY);
        
  
        const now = Date.now();
        const scrollTop = window.scrollY;
        const deltaY = lastScrollTop - scrollTop;
        const deltaTime =    - lastTime;
  
        if (deltaY > 40 && deltaTime < 300 && scrollTop < 200 && shouldShowPopup()) {
          console.log("because of scrolling")
          showPopup();
        }
  
        lastScrollTop = scrollTop;
        lastTime = now;
      })
    }, 10000)

  }
});
